export const writers = [
  {
    id: 1,
    name: "Bobby Diggs",
    photo:
      "https://i.pinimg.com/originals/ae/ec/c2/aeecc22a67dac7987a80ac0724658493.jpg",
  },
  {
    id: 2,
    name: "John Doe",
    photo:
      "https://shiftart.com/wp-content/uploads/2017/04/RC-Profile-Square-1000x1000.jpg",
  },
  {
    id: 3,
    name: "Mary Jane",
    photo:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiNLmJF-SLs2602c7HRUTMF2qGGUVOu2GrD5Xc1ypeyYqdaO35TvGWrPdKiXMQZbCCk0RuYxqNkg84QShjN9DwHhyE0xcJVoKQVG-EvrINDCUyyqgB0hK1KlnxCPaIuNJ8IjBpLTHMD3WhluoS-gQTBFwpyYQpBTegRT8P574xkhw3nu5hEgzZn-nryYck/w1200-h630-p-k-no-nu/download%20(1).jpg",
  },
  {
    id: 4,
    name: "Lucifer Cruz",
    photo:
      "https://th.bing.com/th/id/OIP.tcEjr6Iaj5yoh2by2XB2LQHaHa?rs=1&pid=ImgDetMain",
  },
  {
    id: 5,
    name: "Michelle Dy",
    photo:
      "https://th.bing.com/th/id/OIP.eqWZZ_heeTqdWYRJlTNhKAHaHa?rs=1&pid=ImgDetMain",
  },
  {
    id: 6,
    name: "Felix Madrigal",
    photo:
      "https://th.bing.com/th/id/OIP.-IZY3A-h7MK9MuXj03WybgAAAA?rs=1&pid=ImgDetMain",
  },
  {
    id: 7,
    name: "Mary Jane",
    photo:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiNLmJF-SLs2602c7HRUTMF2qGGUVOu2GrD5Xc1ypeyYqdaO35TvGWrPdKiXMQZbCCk0RuYxqNkg84QShjN9DwHhyE0xcJVoKQVG-EvrINDCUyyqgB0hK1KlnxCPaIuNJ8IjBpLTHMD3WhluoS-gQTBFwpyYQpBTegRT8P574xkhw3nu5hEgzZn-nryYck/w1200-h630-p-k-no-nu/download%20(1).jpg",
  },
];

export function shuffle(array) {
  // Create a copy of the array
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
}




export const peopleByGroup = [
  {
    name: "Writers",
    persons: shuffle(writers)
  },
  {
    name: "Director",
    persons: shuffle(writers)
  },
  {
    name: "Dancers",
    persons: shuffle(writers)
  },
  {
    name: "Actor",
    persons: shuffle(writers)
  },
  {
    name: "Choreographer",
    persons: shuffle(writers)
  },
];

export const recentMilestonesData = [
  {
    id: 1,
    name: "Lucifer Cruz",
    image: "/assets/images/img-001.png",
  },
  {
    id: 2,
    name: "Michelle Dy",
    image: "/assets/images/img-002.png",
  },
  {
    id: 3,
    name: "John Doe",
    image: "/assets/images/img-003.png",
  },
  {
    id: 4,
    name: "Mary Jane",
    image: "/assets/images/img-004.png",
  },
  {
    id: 5,
    name: "Lucifer Cruz",
    image: "/assets/images/img-001.png",
  },
];

export const headerLinks = [
  {
    id: 1,
    label: "Features",
    path: "/features"
  },
  // {
  //   id: 2,
  //   label: "About Us",
  //   path: "/about-us"
  // },
  {
    id: 3,
    label: "Pricing",
    path: "/plans"
  },
  {
    id: 4,
    label: "FAQs",
    path: "/faqs"
  }
];

